import {
  ActionHandler,
  ActionRegistry,
  ValidationResult,
} from '@/core/ambient-intelligence/components/registries/ActionRegistry';
import { ActionSpec } from '@/core/ambient-intelligence/types/ambient-intelligence.types';
import { broadcastMessage } from '@/core/apis/share-space-api';

export class ShareActionHandler implements ActionHandler {
  async execute(action: ActionSpec, context: any): Promise<any> {
    const { content } = context;
    const shareData = action.params;

    try {
      // Call the broadcast message API
      const result = await broadcastMessage(shareData);

      return {
        success: true,
        result: {
          type: 'update_state',
          data: result,
        },
      };
    } catch (error) {
      console.error('Share action failed:', error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Failed to share content',
      };
    }
  }

  canHandle(action: ActionSpec): boolean {
    return action.type === 'share';
  }

  validate(params: any): ValidationResult {
    if (!params?.userIds || !Array.isArray(params.userIds) || params.userIds.length === 0) {
      return { valid: false, error: 'No recipients selected' };
    }

    if (!params?.contentData) {
      return { valid: false, error: 'Content data is required' };
    }

    return { valid: true };
  }
}

// Register the handler
ActionRegistry.register('share', new ShareActionHandler());
